/**
 * One invalid-row error toast per batch while those counts stay the same.
 *
 * A later status refetch of the same batch must not fire the banner again.
 * The first time the batch reports invalid rows still shows it.
 *
 * @param {{batchId: (number|string), invalidRows: number}} args
 * @param {{batchId: (number|string)|null, invalidRows: number|null}=} lastShown
 * @return {{show: boolean, lastShown: {batchId: (number|string)|null, invalidRows: number|null}}}
 */
export const nextInvalidRowToastState = (
  { batchId, invalidRows },
  lastShown = { batchId: null, invalidRows: null },
) => {
  if (!(invalidRows > 0) || !batchId) {
    return { show: false, lastShown };
  }

  if (lastShown.batchId === batchId && lastShown.invalidRows === invalidRows) {
    return { show: false, lastShown };
  }

  return { show: true, lastShown: { batchId, invalidRows } };
};

export const INVALID_ROW_TOAST = {
  type: "error",
  message:
    "Your upload contains errors. Invalid rows can't be processed - only valid data can be submitted.",
  position: "top-center",
};
